import * as actionTypes from '../constants/actionType';
import * as apiActions from "./apiActions";
import * as apiValues from "../constants/apiValues";
import * as pageActions from "./pageActions";
import * as helpers from "../helpers";


export const initPageHome = () => (dispatch) => {
  dispatch(pageActions.loadPageStart());

  return apiActions.loadSingleType(apiValues.nref.pageHome.endpoint)
    .then((result) => {
      if (!result) {
        throw new Error('page home: CMS returned no page-home record (migrate data or check permissions)');
      }
      const page = apiActions.itemSelectCamelCaseKeys(result, apiValues.nref.pageHome.fieldsUsed);
      page.currentProjects = apiActions.itemSelectCamelCaseKeys(page.currentProjects, apiValues.nref.mProjectsCurrent.fieldsUsed);
      page.getInvolved = apiActions.itemSelectCamelCaseKeys(page.getInvolved, apiValues.nref.mGetInvolved.fieldsUsed);
      page.heroCarousel = apiActions.itemSelectCamelCaseKeys(page.heroCarousel, apiValues.nref.mCarousel.fieldsUsed);
      return page;
    })
    .then((page) => dispatch(pageActions.loadPageSuccess(page)))
    .catch((err) => dispatch(pageActions.loadPageFail(err)));
};

export const searchStart = (query) => {
  return {
    type: actionTypes.PAGE_HOME_SEARCH_START,
    searchQuery: query
  };
};

export const searchSuccess = (data) => {
  return {
    type: actionTypes.PAGE_HOME_SEARCH_SUCCESS,
    data
  };
};

export const doSearch = (query) => dispatch => {
  dispatch(searchStart(query));

  if (query && query.length > 0) {
    const suggest = apiValues.PROJECT_SUGGEST_QUERY;
    const titlePromise = apiActions.loadEndpoint(apiValues.nref.project.endpoint, null, {Title_contains: query, ...suggest})
      .then(results => (results ? apiActions.arraySelectCamelCaseKeys(results, apiValues.nref.project.fieldsUsed) : []));
    const neighborhoodsPromise = apiActions.loadEndpoint(apiValues.nref.project.endpoint, null, {Neighborhoods_contains: query, ...suggest})
      .then(results => (results ? apiActions.arraySelectCamelCaseKeys(results, apiValues.nref.project.fieldsUsed) : []));

    return Promise.all([titlePromise, neighborhoodsPromise])
      .then(([titleResults, neighborhoodsResults]) => {
        const results = {suggestedProjects: helpers.mergeArraysWithoutDuplicatesBasedOnProperty(titleResults, neighborhoodsResults, "id")};
        dispatch(searchSuccess(results));
      });
  }
  else {
    dispatch(searchSuccess({
      suggestedProjects: undefined,
      viewProjectsNear: undefined
    }));
    return Promise.resolve();
  }
};

export const toggleSearch = isSearchOpen => {
  return {
    type: actionTypes.PAGE_HOME_TOGGLE_SEARCH,
    isSearchOpen
  };
};